export const detailGallery = [
    '/assets/img/documents/megamix1.jpg',
    '/assets/img/documents/megamix2.jpg',
    '/assets/img/documents/megamix3.jpg',
    '/assets/img/documents/megamix4.jpg',
    '/assets/img/documents/megamix5.jpg',
    '/assets/img/documents/megamix6.jpg',
    '/assets/img/documents/megamix7.jpg',
    '/assets/img/documents/megamix8.jpg',
    '/assets/img/documents/megamix9.jpg'
    // "/assets/img/detail-gallery/circle-1.png",
    // "/assets/img/detail-gallery/circle-2.png",
    // "/assets/img/detail-gallery/circle-3.png",
    // "/assets/img/detail-gallery/Diamond.png",
    // "/assets/img/detail-gallery/Diamond-1.png",
    // "/assets/img/detail-gallery/Diamond-2.png",
    // "/assets/img/detail-gallery/Diamond-3.png",
    // "/assets/img/detail-gallery/Diamond-4.png",
    // "/assets/img/detail-gallery/Diamond-5.png",
    // "/assets/img/detail-gallery/Diamond-6.png",
    // "/assets/img/detail-gallery/Rectangle.png",
    // "/assets/img/detail-gallery/Rectangle-1.png",
    // "/assets/img/detail-gallery/Rectangle-2.png",
    // "/assets/img/detail-gallery/Rectangle-3.png",
    // "/assets/img/detail-gallery/Rectangle-4.png",
    // "/assets/img/detail-gallery/Rectangle-5.png",
    // "/assets/img/detail-gallery/Square.png",
    // "/assets/img/detail-gallery/Square-1.png",
    // "/assets/img/detail-gallery/Square-2.png",
    // "/assets/img/detail-gallery/Square-3.png",
    // "/assets/img/detail-gallery/Square-4.png",
    // "/assets/img/detail-gallery/Square-5.png",
    // "/assets/img/detail-gallery/Triangle.png",
    // "/assets/img/detail-gallery/Triangle-1.png",
    // "/assets/img/detail-gallery/Triangle-2.png",
    // "/assets/img/detail-gallery/Triangle-3.png",
    // "/assets/img/detail-gallery/Triangle-4.png",
]
